import { createAsyncTypes } from 'utils/ActionCreator'

export const LAST_SEEN_PRODUCT_RELEASE_SAVE_ASYNC = createAsyncTypes(
  'LAST_SEEN_PRODUCT_RELEASE_SAVE_ASYNC',
  'NewRelease'
)
